import { configuratorStatus } from 'utils/status';

const values = ['NotStarted', 'OptOut'] as const;

export const options = values.map((value) => ({
  label: configuratorStatus[value],
  value,
}));
